module.exports = __webpack_public_path__ + "img/user-permission.d9340862.png";